import { render, staticRenderFns } from "./grupJM.vue?vue&type=template&id=156750fa&scoped=true&"
import script from "./grupJM.vue?vue&type=script&lang=js&"
export * from "./grupJM.vue?vue&type=script&lang=js&"
import style0 from "./grupJM.vue?vue&type=style&index=0&id=156750fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156750fa",
  null
  
)

export default component.exports